import Promise from 'es6-promise'
export default Promise



// WEBPACK FOOTER //
// ./src/services/promise.service.js